/* eslint-disable no-async-promise-executor */
import { canvasRequest } from '$/api/canvasRquest';
import APP from '$/api/api';
import type { MaterialParams } from '$/store/useSopStore';
import type {
  NodeMaterialResult,
  CategoryItem,
  CardItem,
  EffectTemplateItem,
} from './type';

// material_list 有值时，优先按ID取这个；
// type && keyword有值时，走搜索；
// type 有值，走默认的创建时间倒序数据
// 以上都为空，返回空
export async function getNodeMaterial(
  params: MaterialParams,
) {
  return new Promise<NodeMaterialResult>(async (resolve, reject) => {
    const response = await canvasRequest.request({
      data: {
        ...params,
        count: 50,
      },
      method: 'POST',
      url: APP.roboneo.api.nodeMaterial,
    });

    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}

// 首页案例列表
export async function getHomeCaseList(params: {
  category_id?: number;
  // 游标
  page?: number;
  // 每页条数
  count?: number;
}) {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise<{ list: CardItem[]; }>(async (resolve, reject) => {
    try {
      const response = await canvasRequest.request({
        params: {
          ...params,
        },
        method: 'GET',
        url: APP.roboneo.api.homeFeaturedCase,
      });

      if (response.status === 200 && response.data.code === 0) {
        resolve(response.data.data);
        return;
      }
      reject(response);
    } catch (error) {
      reject(error);
    }
  });
}

/**
 * 首页案例详情
 *
 * @export
 * @param {string} card_id
 * @return {*}
 */
export async function getHomeCaseInfo(card_id: number) {
  return new Promise<CardItem>(async (resolve, reject) => {
    const response = await canvasRequest.request({
      params: { card_id },
      method: 'GET',
      url: APP.roboneo.api.homeFeaturedCaseInfo,
    });

    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}

/**
 * 首页案例分类
 *
 * @export
 * @return {*}
 */
export async function getHomeCaseCategory() {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise<{ list: CategoryItem[]; }>(async (resolve, reject) => {
    const response = await canvasRequest.request({
      method: 'GET',
      url: APP.roboneo.api.homeFeaturedCaseCategory,
    });

    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}

/**
 * 爆款模板案例
 *
 * @export
 * @return {*}
 */
export async function getEffectTemplateList() {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise<{ list: EffectTemplateItem[]; }>(async (resolve, reject) => {
    const response = await canvasRequest.request({
      method: 'GET',
      url: APP.roboneo.api.effectTemplateList,
    });

    if (response.status === 200 && response.data.code === 0) {
      resolve(response.data.data);
      return;
    }
    reject(response);
  });
}
